import {createSlice} from "@reduxjs/toolkit";
import {getVideos} from "./action";

const initialState = {
  state: [],
  loading: true,
  error: ''
} as BaseState<Video[]>

const slice = createSlice({
  name: 'videoSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getVideos.pending, (state) => ({
        ...state,
        loading: true
      })
    )
    builder.addCase(getVideos.fulfilled, (state, action) => {
        const videosPagination = action.payload
        return {
          state: [...videosPagination.items],
          loading: false,
          error: null
        }
      }
    )
    builder.addCase(getVideos.rejected, () => ({
        state: [],
        loading: false,
        error: 'Failed to get videos, please try again'
      })
    )
  }
})

export default slice
